module.exports = __webpack_public_path__ + "d94e20c1/img/comments-icon.fdec7fdb.svg";